import { memo } from "react";
import { SettingModalHeader } from "../../components/setting-modal-header";
import { SubscriptionManagementContent } from "./subscription-management-content";

interface SubscriptionManagementPageProps {
  onBack?: () => void;
  onUpgrade?: () => void;
}

export default memo(function SubscriptionManagementPage({
  onBack,
  onUpgrade,
}: SubscriptionManagementPageProps) {
  return (
    <div className="flex h-full w-full flex-col bg-white">
      <SettingModalHeader title="Subscription" onBack={onBack} />
      <SubscriptionManagementContent onUpgrade={onUpgrade} />
    </div>
  );
});
